import getOcTheme from '../../theme/services/getOcTheme';

const { palette, shape } = getOcTheme();

export default {
  '& kbd': {
    textDecoration: 'none',
    textAlign: 'center',
    lineHeight: '1.35rem',
    display: 'inline-block',
    padding: '1px 6px',
    margin: '0 5px',
    borderRadius: shape.borderRadius,
    border: `1px solid ${palette.layout.line.divider}`,
    borderBottomWidth: 2,
    background: palette.background.alternative,
  },
};
